import { defineComponent as _defineComponent } from 'vue'
import { vShow as _vShow, createElementVNode as _createElementVNode, withDirectives as _withDirectives, unref as _unref, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, normalizeClass as _normalizeClass, createBlock as _createBlock, normalizeStyle as _normalizeStyle, resolveDirective as _resolveDirective, toDisplayString as _toDisplayString, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '../../assets/chat/comment_active.svg'
import _imports_1 from '../../assets/chat/comment_default.svg'
import _imports_2 from '../../assets/chat/empty-img-default.svg'
import _imports_3 from '../../assets/chat/avatar_active.svg'
import _imports_4 from '../../assets/chat/avatar_default.svg'
import _imports_5 from '../../assets/chat/phone-telephone_active.svg'
import _imports_6 from '../../assets/chat/phone-telephone_default.svg'


const _withScopeId = n => (_pushScopeId("data-v-6559b419"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "leftTabs" }
const _hoisted_2 = { class: "custom-tabs-label" }
const _hoisted_3 = {
  src: _imports_0,
  alt: ""
}
const _hoisted_4 = {
  src: _imports_1,
  alt: ""
}
const _hoisted_5 = ["infinite-scroll-disabled"]
const _hoisted_6 = {
  key: 0,
  class: "skeletonWrapper"
}
const _hoisted_7 = { class: "skeleton" }
const _hoisted_8 = { class: "skeletonItemWrapper" }
const _hoisted_9 = { class: "skTop" }
const _hoisted_10 = {
  key: 1,
  style: {"height":"100%"}
}
const _hoisted_11 = { class: "hoverContact" }
const _hoisted_12 = ["element-loading-text"]
const _hoisted_13 = {
  key: 0,
  class: "noMore"
}
const _hoisted_14 = {
  key: 2,
  class: "empty"
}
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_2,
  class: "empty-img",
  alt: ""
}, null, -1))
const _hoisted_16 = { class: "empty-text" }
const _hoisted_17 = { class: "custom-tabs-label" }
const _hoisted_18 = {
  src: _imports_3,
  alt: ""
}
const _hoisted_19 = {
  src: _imports_4,
  alt: ""
}
const _hoisted_20 = ["infinite-scroll-disabled"]
const _hoisted_21 = {
  key: 0,
  class: "skeletonWrapper"
}
const _hoisted_22 = { class: "skeletonMail" }
const _hoisted_23 = {
  key: 1,
  style: {"height":"100%"}
}
const _hoisted_24 = ["element-loading-text"]
const _hoisted_25 = {
  key: 0,
  class: "noMore"
}
const _hoisted_26 = {
  key: 2,
  class: "empty"
}
const _hoisted_27 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_2,
  class: "empty-img",
  alt: ""
}, null, -1))
const _hoisted_28 = { class: "empty-text" }
const _hoisted_29 = { class: "custom-tabs-label" }
const _hoisted_30 = {
  src: _imports_5,
  alt: ""
}
const _hoisted_31 = {
  src: _imports_6,
  alt: ""
}
const _hoisted_32 = ["infinite-scroll-disabled"]
const _hoisted_33 = {
  key: 0,
  class: "skeletonWrapper"
}
const _hoisted_34 = { class: "skeleton2" }
const _hoisted_35 = { class: "skColumn" }
const _hoisted_36 = {
  key: 1,
  style: {"height":"100%"}
}
const _hoisted_37 = { class: "hoverContact" }
const _hoisted_38 = ["element-loading-text"]
const _hoisted_39 = {
  key: 0,
  class: "noMore"
}
const _hoisted_40 = {
  key: 2,
  class: "empty"
}
const _hoisted_41 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_2,
  class: "empty-img",
  alt: ""
}, null, -1))
const _hoisted_42 = { class: "empty-text" }

import { ref, onMounted, nextTick, computed, watch } from "vue";
import { useStore } from "vuex";
import type { TabsPaneContext } from "element-plus";
import contactItem from "@/components/whatsapp/tabItem/contactItem.vue";
import mailListItem from "@/components/whatsapp/tabItem/mailListItem.vue";
import phoneItem from "@/components/whatsapp/tabItem/phoneItem.vue";
import { useI18n } from "vue-i18n";
import {
  getContactsListApi,
  getPhoneListApi,
  getChatListApi,
} from "@/api/chat/index";
import emitter from "@/utils/eventBus";
import moment from "moment";
import { getQueryParam, gaEvent } from "@/utils/format";
import {
  contactDemoRes,
  mailDemoRes,
  phoneDemoRes,
} from "@/components/whatsapp/config/chatConfig";
import { event } from "vue-gtag";

type contactType = {
  name: string;
  last_message: string;
  date: string;
  key: string;
};

// isFromScroll是否是无限滚动触底时触发的
type mailType = {
  label: string;
  children: Array<mailType>;
};
type phoneType = {
  contactName: string;
  status: string;
  date: string;
  count: number;
  avatar?: string | null;
};

export default /*#__PURE__*/_defineComponent({
  __name: 'leftTabs',
  setup(__props) {

const store = useStore();
// const isDemo = getQueryParam(location.href, 'isDemo')
// store.commit('setIsDemo', parseInt(isDemo))
// console.log(store.state.isDemo);
const isDemoRef = computed(() => store.state.isDemo);

// 当前激活的tabItem
// const activeTabName = ref('first')
const activeTabName = computed(() => store.state.activeTabName);

const deviceId = computed(() => store.state.currentDeviceInfo.id);

// 点击tabItem触发该函数
const handleTabItemClick = async (tab: TabsPaneContext, e: Event) => {
  // console.log(tab.props.name);
  if (tab.props.name === "second") {
    gaEvent("Contact_Choose", {
      event_category: "WhatsApp_Function",
      event_label: "None",
    });
  }
  if (tab.props.name === "third") {
    gaEvent("Call_Choose", {
      event_category: "WhatsApp_Function",
      event_label: "None",
    });
  }
  // if (activeTabName.value === 'first') {
  //     // 更新会话列表数据
  //     // 恢复默认值
  //     contactPageNum.value = 1
  //     contactList.value = []
  //     cumulativeContactList = []
  //     contactLoading.value = false
  //     contactGlobalLoading.value = true
  //     await getContactList()
  // }
  // if (activeTabName.value === 'third') {
  //     // 更新通话记录列表数据
  //     phoneList.value = []
  //     cumulativePhoneList = []
  //     phonePageNum.value = 1 // 页码
  //     currentPhoneItemIndex.value = 0 // phoneList中当前点击项下标
  //     phoneGlobalLoading.value = true
  //     await getPhoneList()
  // }
  store.commit("setActiveTabName", tab.props.name);
  console.log("修改左侧tab:", store.state.activeTabName);

};

watch([activeTabName, deviceId], async ([tabNewVal, idNewVal]) => {
  //   console.log("activeTabName改变了", tabNewVal, idNewVal);
  if (tabNewVal === "first") {
    // 更新会话列表数据
    // 恢复默认值
    contactPageNum.value = 1;
    contactList.value = [];
    cumulativeContactList = [];
    noMoreContact.value = false;
    contactLoading.value = false;
    contactGlobalLoading.value = true;
    // tab激活项改变时，重置会话列表的激活样式在列表第一项
    leftChatActive.value = 0;
    await getContactList();
  }
  if (tabNewVal === "second") {
    // 更新会话列表数据
    // 恢复默认值
    mailPageNum.value = 1;
    mailList.value = [];
    cumulativeMailList = [];
    noMoreMail.value = false;
    mailLoading.value = false;
    mailGlobalLoading.value = true;
    await getMailList();
  }
  if (tabNewVal === "third") {
    // console.log('activeTabName third');

    // 更新通话记录列表数据
    phoneList.value = [];
    cumulativePhoneList = [];
    noMorePhone.value = false;
    phonePageNum.value = 1; // 页码
    currentPhoneItemIndex.value = 0; // phoneList中当前点击项下标
    phoneGlobalLoading.value = true;
    // console.log(phoneGlobalLoading.value);
    await getPhoneList(false, true);
  }
});

// ==========leftChat============
const leftChatActive = ref(0);
const contactItemClick = (index: any, item: any) => {
  // console.log(item.chat_session_id)
  leftChatActive.value = index;
  store.commit("setClickItemKey", item.chat_session_id);
  store.commit("setSessionClickItem", item);
  // store.commit('setIsClick', true)
};

const datePickerValue = computed(() => store.state.datePickerValue);
// 监听时间筛选值的变化，时间值发生改变后更新左侧会话列表数据、通话记录列表数据
watch([datePickerValue], async (newVal, oldVal) => {
  // console.log('datePickerValue改变了leftTabs')
  /* if (activeTabName.value === 'first') {
        // console.log('datePickerValue改变了，重新请求会话列表数据');
        // 更新会话列表数据
        // 恢复默认值
        contactPageNum.value = 1
        contactList.value = []
        cumulativeContactList = []
        contactLoading.value = false
        contactGlobalLoading.value = true
        await getContactList()
    } */
  if (activeTabName.value === "third") {
    // 更新通话记录列表数据
    phoneList.value = [];
    cumulativePhoneList = [];
    phonePageNum.value = 1; // 页码
    currentPhoneItemIndex.value = 0; // phoneList中当前点击项下标
    phoneGlobalLoading.value = true;
    await getPhoneList();
    store.commit("setClickPhoneItemDetail", phoneList.value[0]);
  }
});

// Tab1：联系人列表的全部内容
const contactList = ref<contactType[]>([]);
let cumulativeContactList: contactType[] = [];
const contactPageNum = ref(1); // 页码
let contactPageSize = ref(20); // 一页多少条数据
let noMoreContact = ref(false); // 是否展示没有更多数据文案
let contactGlobalLoading = ref(true);
const contactLoading = ref(false);
const disabledContactScroll = computed(
  () => contactLoading.value || noMoreContact.value
);
// 获取左侧联系人列表
const getContactList = async (isFromScroll: boolean = false) => {
  // 调用接口获取聊天记录,获取一页的数据
  // console.log(isFromScroll, 'isFromScroll');

  try {
    let onePageContactList: any = [];
    let start = parseInt(datePickerValue.value[0]);
    let end = parseInt(datePickerValue.value[1]);
    const params = {
      device_id: deviceId.value,
      // device_id: '123456789abc',
      app: "whatsapp",
      page: contactPageNum.value,
      page_size: contactPageSize.value,
      // start: start,
      start: 1609430400,
      end: moment().add(12, "M").format("X"),
      // end: end,
    };
    let res: any;
    if (isDemoRef.value) {
      // 如果是demo演示直接展示假数据
      return new Promise((resolve, reject) => {
        setTimeout(() => {
          res = contactDemoRes;
          // console.log('假数据');
          if (res.data.code == 200) {
            // if (!res.data.data.chat_sessions) {
            if (res.data.data.total == 0) {
              // 如果左侧会话列表数据为空
              contactList.value = [];
              contactGlobalLoading.value = false;
              store.commit("setClickItemKey", null);
              store.commit("setSessionClickItem", null);
              if (activeTabName.value == "first" && !isFromScroll) {
                gaEvent("Whatsapp_Info", {
                  event_category: "WhatsApp_Function",
                  event_label: "NoData",
                });
              }
              return;
            }
            onePageContactList = res.data.data.chat_sessions || [];
            contactGlobalLoading.value = false;
            cumulativeContactList =
              cumulativeContactList.concat(onePageContactList);
            contactList.value = cumulativeContactList;
            if (activeTabName.value == "first" && !isFromScroll) {
              if (contactList.value.length > 0) {
                gaEvent("Whatsapp_Info", {
                  event_category: "WhatsApp_Function",
                  event_label: "Data",
                });
              }
            }
            emitter.emit("closeLoading");
            resolve(res.data.data);
          }
        }, 1000);
      });
    } else {
      // console.log('getContactList执行');

      res = await getChatListApi(params);
      if (res.data.code == 200) {
        // if (!res.data.data.chat_sessions) {
        if (res.data.data.total == 0) {
          // 如果左侧会话列表数据为空
          contactList.value = [];
          contactGlobalLoading.value = false;
          store.commit("setClickItemKey", null);
          store.commit("setSessionClickItem", null);
          if (activeTabName.value == "first" && !isFromScroll) {
            gaEvent("Whatsapp_Info", {
              event_category: "WhatsApp_Function",
              event_label: "NoData",
            });
          }
          return;
        }
        onePageContactList = res.data.data.chat_sessions || [];
        // console.log('contactGlobalLoading.value', contactGlobalLoading.value);

        contactGlobalLoading.value = false;
        cumulativeContactList =
          cumulativeContactList.concat(onePageContactList);
        contactList.value = cumulativeContactList;
        store.commit(
          "setClickItemKey",
          (contactList.value[0] as any).chat_session_id
        );
        store.commit("setSessionClickItem", contactList.value[0]);

        if (activeTabName.value == "first" && !isFromScroll) {
          if (contactList.value.length > 0) {
            gaEvent("Whatsapp_Info", {
              event_category: "WhatsApp_Function",
              event_label: "Data",
            });
          }
        }
        // store.commit('setClickItemKey', (contactList.value[0] as any).chat_session_id)
        return new Promise((resolve, reject) => {
          // resolve(onePageContactList)
          resolve(res.data.data);
        });
      }
    }
    // const res = await getChatListApi(params)
    // if (res.data.code == 200) {
    //     // if (!res.data.data.chat_sessions) {
    //     if (res.data.data.total == 0) {
    //         // 如果左侧会话列表数据为空
    //         contactList.value = []
    //         contactGlobalLoading.value = false
    //         store.commit('setClickItemKey', null)
    //         return
    //     }
    //     onePageContactList = res.data.data.chat_sessions || []
    //     contactGlobalLoading.value = false
    //     cumulativeContactList = cumulativeContactList.concat(onePageContactList)
    //     contactList.value = cumulativeContactList
    //     // store.commit('setClickItemKey', (contactList.value[0] as any).chat_session_id)
    //     return new Promise((resolve, reject) => {
    //         // resolve(onePageContactList)
    //         resolve(res.data.data)
    //     })
    // }
  } catch (err) {
    console.log(err);
    contactGlobalLoading.value = false;
    // emitter.emit('closeLoading')
    emitter.emit("closeChatLoading");
  } finally {
    // emitter.emit('closeChatLoading')
  }
  // }
};
onMounted(async () => {
  // 首次渲染页面时，将列表中的第一项数据放进clickMailItemDetail
  contactGlobalLoading.value = true;
  setTimeout(async () => {
    try {
      store.commit("setClickItemKey", null);
      store.commit("setSessionClickItem", null);
      const res: any = await getContactList();
      // console.log(res, 'res');

      const onePageContactList = res.chat_sessions;
      contactGlobalLoading.value = false;
      store.commit(
        "setClickItemKey",
        (contactList.value[0] as any).chat_session_id
      );
      store.commit("setSessionClickItem", contactList.value[0]);
      // emitter.emit("startQuest", (onePageContactList as any)[0].chat_session_id)
    } catch (err) {
      console.log(err);
      emitter.emit("closeLoading");
      emitter.emit("closeChatLoading");
      contactGlobalLoading.value = false;
    }
  }, 100);
});

const loadMoreContactList = () => {
  contactLoading.value = true;
  setTimeout(async () => {
    // console.log("loadMoreContactList");
    contactPageNum.value++;
    const res: any = await getContactList(true);
    const total = res.total;
    contactLoading.value = false;
    if (contactList.value.length >= total) {
      // 如果当前列表总长度大于等于接口返回的数据总长度，则显示没有更多数据文案
      noMoreContact.value = true;
    }
  }, 100);
};

// =========leftMail=========
// Tab2: 通讯录列表
const mailList = ref<mailType[]>([]);
let cumulativeMailList: mailType[] = [];
let mailPageNum = ref(0); // 页码
let mailPageSize = ref(15); // 一页多少条数据
let noMoreMail = ref(false); // 是否展示没有更多数据文案
let mailGlobalLoading = ref(true);
const getMailList = async (isFromScroll: boolean = false) => {
  try {
    // 调接口拿数据
    let onePageMailList: mailType[] = [];
    mailPageNum.value = mailPageNum.value + 1;
    const params = {
      device_id: deviceId.value,
      // device_id: '123456789abc',
      app: "whatsapp",
      // page: mailPageNum.value,
    };

    let res: any;
    if (isDemoRef.value) {
      // 如果是demo演示直接展示假数据
      return new Promise((resolve, reject) => {
        setTimeout(() => {
          res = mailDemoRes;
          if (res.data.code == 200) {
            onePageMailList = res.data.data.contacts;
            mailGlobalLoading.value = false;
            if (mailList.value.length == res.data.data.length) {
              cumulativeMailList = onePageMailList;
              // 当前列表数据与数据库总条数相等，这说明数据已经全部加载完成
              noMoreMail.value = true;
            } else {
              cumulativeMailList = cumulativeMailList.concat(onePageMailList);
            }
            mailList.value = cumulativeMailList;
            if (mailList.value.length > 0) {
              if (activeTabName.value == "second" && !isFromScroll) {
                gaEvent("Whatsapp_Contact", {
                  event_category: "WhatsApp_Function",
                  event_label: "Data",
                });
              }
              store.commit(
                "setClickMailItemDetail",
                mailList.value[0].children[0]
              );
            } else {
              if (activeTabName.value == "second" && !isFromScroll) {
                gaEvent("Whatsapp_Contact", {
                  event_category: "WhatsApp_Function",
                  event_label: "NoData",
                });
              }
              store.commit("setClickMailItemDetail", null);
            }
            resolve(res.data.data);
            noMoreMail.value = true;
            emitter.emit("closeLoading");
          }
        }, 500);
      });
    } else {
      res = await getContactsListApi(params);
      if (res.data.code == 200) {
        onePageMailList = res.data.data.contacts;
        mailGlobalLoading.value = false;
        if (mailList.value.length == res.data.data.length) {
          cumulativeMailList = onePageMailList;
          // 当前列表数据与数据库总条数相等，这说明数据已经全部加载完成
          noMoreMail.value = true;
        } else {
          cumulativeMailList = cumulativeMailList.concat(onePageMailList);
        }
        mailList.value = cumulativeMailList;
        if (mailList.value.length > 0) {
          store.commit("setClickMailItemDetail", mailList.value[0].children[0]);
          if (activeTabName.value == "second" && !isFromScroll) {
            gaEvent("Whatsapp_Contact", {
              event_category: "WhatsApp_Function",
              event_label: "Data",
            });
          }
        } else {
          store.commit("setClickMailItemDetail", null);
          if (activeTabName.value == "second" && !isFromScroll) {
            gaEvent("Whatsapp_Contact", {
              event_category: "WhatsApp_Function",
              event_label: "NoData",
            });
          }
        }
        return new Promise((resolve, reject) => {
          resolve(res.data.data);
        });
      }
    }
  } catch (err) {
    console.log(err);
    store.commit("setClickMailItemDetail", null);
    mailGlobalLoading.value = false;
  } finally {
    emitter.emit("closeLoading");
  }
};
// onMounted(() => {
//     nextTick(async () => {
//         // 首次渲染页面时，将列表中的第一项数据放进clickMailItemDetail
//         mailGlobalLoading.value = true
//         setTimeout(async () => {
//             const onePageMailList = await getMailList();
//             mailGlobalLoading.value = false
//             store.commit('setClickMailItemDetail', (onePageMailList![0] as any).children[0])
//         }, 1000)
//     })
// });
const mailLoading = ref(false);
const loadMoreMailList = () => {
  // mailPageNum.value = mailPageNum.value + 1
  mailLoading.value = true;
  setTimeout(async () => {
    // console.log("loadMoreMailList");
    // let onePageMailList: any = []
    const res: any = await getMailList(true);
    mailLoading.value = false;
    // if (mailList.value.length % mailPageSize.value != 0) {
    //     // 如果当前列表总长度不是 pageSize的倍数，则显示没有更多数据文案
    //     noMoreMail.value = true;
    // }
    // console.log('mailList', mailList.value);
  }, 100);
};
// 正在加载数据 或者 已经没有更多数据时 禁止滚动
const disabledMailScroll = computed(
  () => mailLoading.value || noMoreMail.value
);

// ==========leftPhone============
// Tab3: 通话记录列表
const phoneList = ref<any>([]);
let cumulativePhoneList: phoneType[] = [];
let phonePageNum = ref(1); // 页码
let phonePageSize = ref(15); // 一页多少条数据
let noMorePhone = ref(false); // 是否展示没有更多数据文案
let currentPhoneItemIndex = ref(0); // phoneList中当前点击项下标
const disabledPhoneScroll = computed(
  () => phoneLoading.value || noMorePhone.value
);
let phoneGlobalLoading = ref(true);
const phoneItemClick = (item: any, index: any) => {
  currentPhoneItemIndex.value = index;
  store.commit("setClickPhoneItemDetail", item);
};

// phoneDemoRes
const getPhoneList = async (
  isFromScroll: boolean = false,
  isClear: boolean = false
) => {
  try {
    if (isClear) {
      // console.log('clear');
      // 如果是切换设备id导致的重新请求接口数据, 则重置原来的数据列表
      mailList.value = [];
      cumulativeMailList = [];
      mailPageNum.value = 1;
    }
    // 调接口拿数据
    let onePagePhoneList: phoneType[] = [];
    let start = parseInt(datePickerValue.value[0]);
    let end = parseInt(datePickerValue.value[1]);
    const params = {
      device_id: deviceId.value,
      // device_id: '123456789abc',
      app: "whatsapp",
      start: start,
      end: end,
      page: phonePageNum.value,
    };
    // phoneGlobalLoading.value = true

    let res: any;
    if (isDemoRef.value) {
      return new Promise((resolve, reject) => {
        setTimeout(() => {
          res = phoneDemoRes;
          if (res.data.code == 200) {
            onePagePhoneList = res.data.data.calls;
            // phoneGlobalLoading.value = false
            if (res.data.data.total === 0) {
              phoneList.value = [];
              phoneGlobalLoading.value = false;
              store.commit("setClickPhoneItemDetail", {});
              if (activeTabName.value == "third" && !isFromScroll) {
                gaEvent("Whatsapp_Call", {
                  event_category: "WhatsApp_Function",
                  event_label: "NoData",
                });
              }
              return [];
            }
            cumulativePhoneList = cumulativePhoneList.concat(onePagePhoneList);
            phoneList.value = cumulativePhoneList;

            if (activeTabName.value == "third" && !isFromScroll) {
              if (phoneList.value.length > 0) {
                gaEvent("Whatsapp_Call", {
                  event_category: "WhatsApp_Function",
                  event_label: "Data",
                });
              }
            }
            store.commit("setClickPhoneItemDetail", phoneList.value[0]);
            phoneGlobalLoading.value = false;
            emitter.emit("closeLoading");
            resolve(res.data.data);
          }
        }, 1000);
      });
    } else {
      const phoneSourceRef = computed(() => store.state.phoneSource);
      // 取消掉上一次请求
      phoneSourceRef.value &&
        phoneSourceRef.value.cancel("请勿频繁请求通讯录列表接口");
      res = await getPhoneListApi(params);
      if (res.data.code == 200) {
        onePagePhoneList = res.data.data.calls;
        phoneGlobalLoading.value = false;
        // if (onePagePhoneList.length === 0) {
        if (res.data.data.total === 0) {
          phoneList.value = [];
          phoneGlobalLoading.value = false;
          store.commit("setClickPhoneItemDetail", {});
          if (activeTabName.value == "third" && !isFromScroll) {
            gaEvent("Whatsapp_Call", {
              event_category: "WhatsApp_Function",
              event_label: "NoData",
            });
          }
          return [];
        }
        cumulativePhoneList = cumulativePhoneList.concat(onePagePhoneList);
        phoneList.value = cumulativePhoneList;

        store.commit("setClickPhoneItemDetail", phoneList.value[0]);
        if (activeTabName.value == "third" && !isFromScroll) {
          if (phoneList.value.length > 0) {
            gaEvent("Whatsapp_Call", {
              event_category: "WhatsApp_Function",
              event_label: "Data",
            });
          }
        }
        return res.data.data;
      }
    }
  } catch (err) {
    console.log(err);
    phoneGlobalLoading.value = false;
  } finally {
    emitter.emit("closeLoading");
  }
};
onMounted(async () => {
  phoneGlobalLoading.value = true;
  const res = await getPhoneList(false, true);
  const onePagePhoneList = res.calls;
  phoneGlobalLoading.value = false;
  if (onePagePhoneList) {
    store.commit("setClickPhoneItemDetail", (onePagePhoneList as any)[0]);
  }
});

const phoneLoading = ref(false);
const loadMorePhoneList = () => {
  // console.log('loadMorePhoneList');
  phonePageNum.value = phonePageNum.value + 1;
  // console.log(phonePageNum.value, 'phonePageNum.value');
  phoneLoading.value = true;
  setTimeout(async () => {
    let onePageMailList: any = [];
    const res = await getPhoneList(true);
    phoneLoading.value = false;
    if (phoneList.value.length >= res.total) {
      // 如果当前列表总长度不是 pageSize的倍数，则显示没有更多数据文案
      noMorePhone.value = true;
    }
  }, 100);
};

return (_ctx: any,_cache: any) => {
  const _component_el_skeleton_item = _resolveComponent("el-skeleton-item")!
  const _component_el_skeleton = _resolveComponent("el-skeleton")!
  const _component_el_tab_pane = _resolveComponent("el-tab-pane")!
  const _component_el_tabs = _resolveComponent("el-tabs")!
  const _directive_loading = _resolveDirective("loading")!
  const _directive_infinite_scroll = _resolveDirective("infinite-scroll")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_el_tabs, {
      modelValue: activeTabName.value,
      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((activeTabName).value = $event)),
      class: "leftBox",
      onTabClick: handleTabItemClick,
      stretch: true
    }, {
      default: _withCtx(() => [
        _createVNode(_component_el_tab_pane, {
          label: "Contact",
          name: "first",
          lazy: true
        }, {
          label: _withCtx(() => [
            _createElementVNode("span", _hoisted_2, [
              _withDirectives(_createElementVNode("img", _hoisted_3, null, 512), [
                [_vShow, activeTabName.value == 'first']
              ]),
              _withDirectives(_createElementVNode("img", _hoisted_4, null, 512), [
                [_vShow, activeTabName.value != 'first']
              ])
            ])
          ]),
          default: _withCtx(() => [
            _withDirectives((_openBlock(), _createElementBlock("div", {
              "infinite-scroll-immediate": false,
              "infinite-scroll-disabled": disabledContactScroll.value,
              "infinite-scroll-distance": "1",
              style: {"overflow":"auto","height":"100%"},
              class: "leftList"
            }, [
              (_unref(contactGlobalLoading))
                ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
                    _createVNode(_component_el_skeleton, {
                      style: {"--el-skeleton-circle-size":"40px","width":"100%"},
                      loading: _unref(contactGlobalLoading),
                      animated: true,
                      count: 9
                    }, {
                      template: _withCtx(() => [
                        _createElementVNode("div", _hoisted_7, [
                          _createVNode(_component_el_skeleton_item, {
                            variant: "circle",
                            style: {"margin-right":"12px"}
                          }),
                          _createElementVNode("div", _hoisted_8, [
                            _createElementVNode("div", _hoisted_9, [
                              _createVNode(_component_el_skeleton_item, {
                                variant: "text",
                                style: {"width":"40%"}
                              }),
                              _createVNode(_component_el_skeleton_item, {
                                variant: "text",
                                style: {"width":"40%"}
                              })
                            ]),
                            _createVNode(_component_el_skeleton_item, {
                              variant: "text",
                              style: {"width":"85%"}
                            })
                          ])
                        ])
                      ]),
                      _: 1
                    }, 8, ["loading"])
                  ]))
                : _createCommentVNode("", true),
              (contactList.value.length > 0)
                ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
                    _createElementVNode("div", _hoisted_11, [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(contactList.value, (item, index) => {
                        return (_openBlock(), _createBlock(contactItem, {
                          key: index,
                          item: item,
                          onClick: ($event: any) => (contactItemClick(index, item)),
                          class: _normalizeClass([leftChatActive.value == index ? 'active' : ''])
                        }, null, 8, ["item", "onClick", "class"]))
                      }), 128))
                    ]),
                    _withDirectives(_createElementVNode("div", {
                      "element-loading-text": _ctx.$t('chat.loadingText'),
                      style: _normalizeStyle({ 'margin-top': contactLoading.value ? '40px' : '10px' })
                    }, null, 12, _hoisted_12), [
                      [_directive_loading, contactLoading.value]
                    ]),
                    (_unref(noMoreContact))
                      ? (_openBlock(), _createElementBlock("div", _hoisted_13, _toDisplayString(_ctx.$t("chat.noMoreText")), 1))
                      : _createCommentVNode("", true)
                  ]))
                : (!_unref(contactGlobalLoading))
                  ? (_openBlock(), _createElementBlock("div", _hoisted_14, [
                      _hoisted_15,
                      _createElementVNode("div", _hoisted_16, _toDisplayString(_ctx.$t("chat.noInfoText")), 1)
                    ]))
                  : _createCommentVNode("", true)
            ], 8, _hoisted_5)), [
              [_directive_infinite_scroll, loadMoreContactList]
            ])
          ]),
          _: 1
        }),
        _createVNode(_component_el_tab_pane, {
          label: "Mail",
          name: "second",
          lazy: true
        }, {
          label: _withCtx(() => [
            _createElementVNode("span", _hoisted_17, [
              _withDirectives(_createElementVNode("img", _hoisted_18, null, 512), [
                [_vShow, activeTabName.value == 'second']
              ]),
              _withDirectives(_createElementVNode("img", _hoisted_19, null, 512), [
                [_vShow, activeTabName.value != 'second']
              ])
            ])
          ]),
          default: _withCtx(() => [
            _withDirectives((_openBlock(), _createElementBlock("div", {
              "infinite-scroll-immediate": false,
              "infinite-scroll-disabled": disabledMailScroll.value,
              style: {"overflow":"auto","height":"100%","width":"100%"},
              "infinite-scroll-distance": "1",
              class: "leftList"
            }, [
              (_unref(mailGlobalLoading))
                ? (_openBlock(), _createElementBlock("div", _hoisted_21, [
                    _createVNode(_component_el_skeleton, {
                      style: {"--el-skeleton-circle-size":"40px","width":"100%"},
                      loading: _unref(mailGlobalLoading),
                      animated: true,
                      count: 10
                    }, {
                      template: _withCtx(() => [
                        _createElementVNode("div", _hoisted_22, [
                          _createVNode(_component_el_skeleton_item, {
                            variant: "circle",
                            style: {"margin-right":"12px"}
                          }),
                          _createVNode(_component_el_skeleton_item, {
                            variant: "text",
                            style: {"width":"55%"}
                          })
                        ])
                      ]),
                      _: 1
                    }, 8, ["loading"])
                  ]))
                : _createCommentVNode("", true),
              (mailList.value.length > 0)
                ? (_openBlock(), _createElementBlock("div", _hoisted_23, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(mailList.value, (item, index) => {
                      return (_openBlock(), _createBlock(mailListItem, {
                        key: index,
                        item: item
                      }, null, 8, ["item"]))
                    }), 128)),
                    _withDirectives(_createElementVNode("div", {
                      "element-loading-text": _ctx.$t('chat.loadingText'),
                      style: _normalizeStyle({ 'margin-top': mailLoading.value ? '40px' : '10px' })
                    }, null, 12, _hoisted_24), [
                      [_directive_loading, mailLoading.value]
                    ]),
                    (_unref(noMoreMail))
                      ? (_openBlock(), _createElementBlock("div", _hoisted_25, _toDisplayString(_ctx.$t("chat.noMoreText")), 1))
                      : _createCommentVNode("", true)
                  ]))
                : (!_unref(mailGlobalLoading))
                  ? (_openBlock(), _createElementBlock("div", _hoisted_26, [
                      _hoisted_27,
                      _createElementVNode("div", _hoisted_28, _toDisplayString(_ctx.$t("chat.noAddressText")), 1)
                    ]))
                  : _createCommentVNode("", true)
            ], 8, _hoisted_20)), [
              [_directive_infinite_scroll, loadMoreMailList]
            ])
          ]),
          _: 1
        }),
        _createVNode(_component_el_tab_pane, {
          label: "Phone",
          name: "third",
          lazy: true
        }, {
          label: _withCtx(() => [
            _createElementVNode("span", _hoisted_29, [
              _withDirectives(_createElementVNode("img", _hoisted_30, null, 512), [
                [_vShow, activeTabName.value == 'third']
              ]),
              _withDirectives(_createElementVNode("img", _hoisted_31, null, 512), [
                [_vShow, activeTabName.value != 'third']
              ])
            ])
          ]),
          default: _withCtx(() => [
            _withDirectives((_openBlock(), _createElementBlock("div", {
              "infinite-scroll-immediate": false,
              "infinite-scroll-disabled": disabledPhoneScroll.value,
              "infinite-scroll-distance": "1",
              style: {"overflow":"auto","height":"100%"},
              class: "leftList"
            }, [
              (_unref(phoneGlobalLoading))
                ? (_openBlock(), _createElementBlock("div", _hoisted_33, [
                    _createVNode(_component_el_skeleton, {
                      style: {"--el-skeleton-circle-size":"40px","width":"100%"},
                      loading: _unref(phoneGlobalLoading),
                      animated: true,
                      count: 9
                    }, {
                      template: _withCtx(() => [
                        _createElementVNode("div", _hoisted_34, [
                          _createVNode(_component_el_skeleton_item, {
                            variant: "circle",
                            style: {"margin-right":"12px"}
                          }),
                          _createElementVNode("div", _hoisted_35, [
                            _createVNode(_component_el_skeleton_item, {
                              variant: "text",
                              style: {"width":"80%","margin-bottom":"8px"}
                            }),
                            _createVNode(_component_el_skeleton_item, {
                              variant: "text",
                              style: {"width":"80%"}
                            })
                          ]),
                          _createVNode(_component_el_skeleton_item, {
                            variant: "text",
                            style: {"width":"25%"}
                          })
                        ])
                      ]),
                      _: 1
                    }, 8, ["loading"])
                  ]))
                : _createCommentVNode("", true),
              (phoneList.value.length > 0)
                ? (_openBlock(), _createElementBlock("div", _hoisted_36, [
                    _createElementVNode("div", _hoisted_37, [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(phoneList.value, (item, index) => {
                        return (_openBlock(), _createBlock(phoneItem, {
                          key: index,
                          item: item,
                          class: _normalizeClass([_unref(currentPhoneItemIndex) == index ? 'active' : '']),
                          onClick: ($event: any) => (phoneItemClick(item, index))
                        }, null, 8, ["item", "class", "onClick"]))
                      }), 128))
                    ]),
                    _withDirectives(_createElementVNode("div", {
                      "element-loading-text": _ctx.$t('chat.loadingText'),
                      style: _normalizeStyle({ 'margin-top': phoneLoading.value ? '40px' : '10px' }),
                      class: "mailLoading"
                    }, null, 12, _hoisted_38), [
                      [_directive_loading, phoneLoading.value]
                    ]),
                    (_unref(noMorePhone))
                      ? (_openBlock(), _createElementBlock("div", _hoisted_39, _toDisplayString(_ctx.$t("chat.noMoreText")), 1))
                      : _createCommentVNode("", true)
                  ]))
                : (!_unref(phoneGlobalLoading))
                  ? (_openBlock(), _createElementBlock("div", _hoisted_40, [
                      _hoisted_41,
                      _createElementVNode("div", _hoisted_42, _toDisplayString(_ctx.$t("chat.noCallText")), 1)
                    ]))
                  : _createCommentVNode("", true)
            ], 8, _hoisted_32)), [
              [_directive_infinite_scroll, loadMorePhoneList]
            ])
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 8, ["modelValue"])
  ]))
}
}

})